import { ActionIcon, Group, Indicator, Tooltip } from '@mantine/core';
import { TableColumnAction } from 'utils/models';

interface Props<T> {
  item: T;
  actions: TableColumnAction<T>[];
}

export const TableColumnActions = <T,>({ item, actions }: Props<T>) => {
  return (
    <Group gap={'xs'}>
      {actions.map(
        ({ visible, tooltip, onClick, variant, indicator, icon, isLoading }: TableColumnAction<T>, index) => {
          if (visible && !visible(item)) {
            return null;
          }

          const handleClick = () => {
            if (!onClick) return;
            onClick(item);
          };

          const renderActionIcon = () => {
            return (
              <ActionIcon
                onClick={handleClick}
                variant={variant || 'outline'}
                color={'var(--mantine-color-blue-5)'}
                size={'sm'}
                loading={isLoading?.(item)}
              >
                {icon}
              </ActionIcon>
            );
          };

          return (
            <Tooltip label={tooltip} key={index}>
              {indicator && indicator(item) ? (
                <Indicator withBorder size={11} offset={1} color={'var(--mantine-color-turquoise-5)'}>
                  {renderActionIcon()}
                </Indicator>
              ) : (
                renderActionIcon()
              )}
            </Tooltip>
          );
        },
      )}
    </Group>
  );
};
